export default {
  en: {
    'login.components.login-panel.title': 'Sign In',
  },
};
